import { render, staticRenderFns } from "./LogisticsDetail.vue?vue&type=template&id=42afc6b1&scoped=true&"
import script from "./LogisticsDetail.vue?vue&type=script&lang=js&"
export * from "./LogisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsDetail.vue?vue&type=style&index=0&id=42afc6b1&lang=scss&scoped=true&"
import style1 from "./LogisticsDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afc6b1",
  null
  
)

export default component.exports